import { useState } from 'react';

const useCityToCoordinates = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCoordinates = async (city) => {
    if (!city || typeof city !== 'string' || city.trim().length === 0) {
      setError('Please provide a valid city name');
      return null;
    }

    setLoading(true);
    setError(null);
    
    try {
      const url = `https://nominatim.openstreetmap.org/search?city=${encodeURIComponent(city.trim())}&format=json&limit=1&addressdetails=0`;
      
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'User-Agent': 'AstroApp/1.0'
        },
        signal: controller.signal
      });
      
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data && data.length > 0) {
        const { lat, lon } = data[0];
        return { 
          lat: parseFloat(lat), 
          lon: parseFloat(lon) 
        };
      } else {
        throw new Error(`No coordinates found for "${city}"`);
      }
    } catch (err) {
      let errorMessage = 'Failed to fetch coordinates';
      
      if (err.name === 'AbortError') {
        errorMessage = 'Request timed out. Please try again.';
      } else if (err.message) {
        errorMessage = err.message;
      }
      
      setError(errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { fetchCoordinates, loading, error };
};

export default useCityToCoordinates;
